import { render, staticRenderFns } from "./report-test copy.vue?vue&type=template&id=255936af"
import script from "./report-test copy.vue?vue&type=script&lang=js"
export * from "./report-test copy.vue?vue&type=script&lang=js"
import style0 from "./report-test copy.vue?vue&type=style&index=0&id=255936af&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports